export class Tax {
  public static add(value: number, taxRate: number): number {
    if (taxRate > 0 && value != 0) {
        return value + (value * (taxRate / 100));
    } else {
        return value;
    }
  }

  public static sub(value:number, taxRate: number): number {
    if (taxRate > 0 && value != 0) {
        return value / (1 + (taxRate / 100));
    } else {
        return value;
    }
  }
}